import Metadata from "../components/Metadata";
import Hero from "../sections/Hero";
import SelectedWork from "../sections/SelectedWork";
import AeroFeature from "../sections/AeroFeature";
import Expertise from "../sections/Expertise";
import AboutPreview from "../sections/AboutPreview";
// import BehindBuildPreview from "../sections/BehindBuildPreview";
import ContactCta from "../sections/ContactCta";
export default function Home() {
  return (
    <>
      <Metadata />
      <Hero />
      <SelectedWork />
      <AeroFeature />
      <Expertise />
      <AboutPreview />
      {/* Hidden while the build notes are being refined.
      <BehindBuildPreview /> */}
      <ContactCta />
    </>
  );
}
